import { Component, OnInit, AfterViewInit, ChangeDetectorRef, SimpleChanges, DoCheck } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MessageService } from 'primeng/api';
import { timeout } from 'rxjs/operators';
import { StorageService } from '../app/air/modules/common/service/storage/storage.service';
import { AuthService } from './air/modules/common/service';
import moment from 'moment';
import { UserSetting } from './air/modules/common/lib/types/general';
import { UserControlService } from './air/modules/common/service/userControl/user-control.service';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, DoCheck {

  checkCount = 0;
  topbarTheme = 'dark';

  menuTheme = 'dark';

  layoutMode = 'light';

  menuMode = 'horizontal';

  isRTL = false;

  inputStyle = 'outlined';
  isRedirectUrl = true;

  ripple: boolean = true;
  isRefresh: boolean; //For US 8229
  hasInitialized: boolean = false;
  private subscription = new SubSink();
  constructor(
    private primeng: PrimeNG,
    private spinner: SpinnerVisibilityService,
    public storageService: StorageService,
    private messageService: MessageService,
    private ref: ChangeDetectorRef,
    private userControlService: UserControlService,
    private authService: AuthService) {

  }

  ngOnInit() {
    // this.navSessionValidation();
    // this.clearTabOnNewTab();
    const isExternalTracking = window.location.href.includes('external-tracking-list/details');
    this.primeng.ripple.set(true);
    this.spinner.show();
    this.spinner.hide();
    let token = this.storageService.getItem('token')
    // if (token) {
    //   this.authService.sessionSchedule();
    // }
    //this.authService.clearTokenOnClose();
    if (!isExternalTracking) {
      this.navSessionValidation();
      // this.clearTokenOnClose();
    }

  }

  navSessionValidation() {
    //#region  Check ocean session is avtive or not
    const email = this.storageService.getItem('email');
    if (email) {
      // Add subscription to SubSink
      this.subscription.add(
        this.userControlService.validateAirUserInOcean({
          userId: email,
          source: 'Air'
        }).subscribe({
          next: (response: boolean) => {
            if (!response) {
              this.messageService.clear();
              this.messageService.add({
                key: 'emptyToster',
                severity: 'warn',
                summary: 'Session Expired',
                detail: 'Your session has expired. Redirecting to login...',
                life: 2000
              });
              setTimeout(() => {
                window.location.href = environment.navigatorlogoutUrl;
              }, 2000);
            }
          },
          error: (error) => {
            console.error('Session validation failed:', error);
            //   window.location.href = environment.navigatorloginUrl;
          }
        })
      );
    } else {
      console.warn('No email found in storage');

    }
    //#endregion
  }
  login(cleanToken: string) {
    this.authService.loginRedirect();
  }

  ngAfterViewInit() {
    // this.messageService.add({
    //     key: 'c',
    //     sticky: true,
    //     severity: 'warn',
    //     summary: 'Load previous session ?',
    // });
    // setTimeout(() => {
    //     this.hideDialog();
    // }, 10000);
    // this.ref.detectChanges();
  }

  // loadSession() {
  //     const filters = this.storageService.getItem('filters');
  //     this.filterService.updateFilterSelection(filters);
  //     this.hideDialog();
  // }  

  ngDoCheck(): void {
    this.checkCount += 1;
    if (this.checkCount == 2500) {
      AuthService.lastApiCall = moment();
      this.checkCount = 0;
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
